import React from 'react';

interface TypingIndicatorProps {
  label?: string;
  className?: string;
}

/**
 * Animated "thinking" indicator with three bouncing dots.
 */
const TypingIndicator: React.FC<TypingIndicatorProps> = ({ label = '', className = '' }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="flex items-center gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-primary dark:bg-primary"
            style={{
              animation: `bounceDot 1.4s ease-in-out ${i * 0.18}s infinite`,
            }}
          />
        ))}
      </span>
      {label && <span className="text-xs text-gray-400 dark:text-gray-500">{label}</span>}
    </div>
  );
};

export default TypingIndicator;
